export function isSandbox(): boolean {
  return process.env.REACT_APP_LOGROCKET_APP_ID?.includes('sandbox') ?? false
}
